"use client";

import { WaitlistType } from "@/types/waitlist/types";
import axios from "axios";
// import { db } from "@/firebase/client";
// import {
//   doc,
//   getDocs,
//   setDoc,
//   updateDoc,
//   collection,
//   where,
//   query,
// deleteDoc,
// orderBy,
// writeBatch,
// } from "firebase/firestore";

type FounderFormType = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  mobileNumber: string;
  linkedinUrl: string;
  websiteUrl: string;
  isPitching: boolean;
  companyName: string;
  fundingStage: string;
  fundingRaised: string;
  fundingRequired: string;
  industry: string[];
  pitchDeck: string;
  serviceProviders: string[];
};

type InvestorFormType = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  mobileNumber: string;
  linkedinUrl: string;
  industry: string[];
  fundingStage: string;
  ticketSize: number[];
  customerGroup: string[];
  preferredLocation: string[];
  fundingDeployed: string;
};

const useWaitList = () => {
  const addToWaitlist = async (data: WaitlistType) => {
    try {
      const { data: response } = await axios.post("/api/waitlist", data);
      return { message: response?.message, data: data };
    } catch (error) {
      throw error;
    }
  };

  const sendEmail = async (data: { username: string; email: string }) => {
    try {
      await axios.post("/api/mail", data);
    } catch (error) {
      throw error;
    }
  };

  const saveFounderForm = async (data: FounderFormType) => {
    try {
      const { data: response } = await axios.post(
        "/api/waitlist/founder",
        data
      );
      return { res: response?.data, data: data };
    } catch (error) {
      throw error;
    }
  };

  const saveInvestorForm = async (data: InvestorFormType) => {
    try {
      const { data: response } = await axios.post(
        "/api/waitlist/investor",
        data
      );
      return { res: response?.data, data: data };
    } catch (error) {
      throw error;
    }
  };

  // const addUserDocsById = (data: any, cb: any) => {
  //   if (data.length) {
  //     try {
  //       if (data.length === 1) {
  //         setDoc(doc(db, "userDocs", data[0].id), data[0])
  //           .then((_res) => {
  //             cb("Organization documents added successfully!", "success");
  //           })
  //           .catch(function (error) {
  //             setOrgLoading(false);
  //             cb("Adding documents failed! Please try again!", "error");
  //             console.log("error", error);
  //           });
  //       } else {
  //         const batch = writeBatch(db);
  //         data.forEach((fd: any) => {
  //           batch.set(doc(db, "userDocs", fd.id), fd);
  //         });
  //         batch
  //           .commit()
  //           .then((_res) => {
  //             setOrgLoading(false);
  //             cb("Documents added successfully!", "success");
  //           })
  //           .catch(function (error) {
  //             setOrgLoading(false);
  //             cb("Document addition failed! Please try again!", "error");
  //             console.log("error", error);
  //           });
  //       }
  //     } catch (error) {
  //       setOrgLoading(false);
  //       console.log("error", error);
  //       cb("Document addition failed! Please try again!", "error");
  //     }
  //   }
  // };

  return { addToWaitlist, sendEmail, saveFounderForm, saveInvestorForm };
};

export default useWaitList;
